import { useCallback } from 'react';
import { useAnalyticsSource } from '@atlassian/jira-issue-context-service/src/main.tsx';
import { useAnalyticsEvents } from '@atlassian/jira-product-analytics-bridge';
import { useTenantContext } from '@atlassian/jira-tenant-context-controller/src/components/tenant-context/index.tsx';
import type { TrackEmbeddedConfluence } from '../../common/types/types.tsx';
import { fireEmbeddedConfluenceAnalytics } from '../utils/analytics.tsx';
import { getParentProduct } from '../utils/index.tsx';

export const useEmbeddedPageTracking = () => {
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const tenantContext = useTenantContext();
	const source = useAnalyticsSource();

	const trackEmbeddedConfluence: TrackEmbeddedConfluence = useCallback(
		({
			eventName,
			action,
			actionSubject,
			contentType,
			projectType,
			embeddedConfluenceSource = 'jiraIssueView',
			eventType = 'ui',
			flow,
			userHasConfluenceAccess,
			tenantHasConfluence,
			crossJoinStatus,
			originProduct,
			requestedProduct,
			isLivePage,
			linkObjectType,
			confluenceContentId,
		}) => {
			const analyticsEvent = createAnalyticsEvent({
				action,
				actionSubject: actionSubject ?? `${eventName}`,
			});

			const attributes = {
				parentProduct: getParentProduct(projectType),
				tenantEditions: tenantContext?.appEditions,
				productEntitlementDetails: tenantContext?.productEntitlementDetails,
				embeddedConfluenceSource,
				flow,
				jiraIssueSurfaceArea: source,
				userHasConfluenceAccess,
				tenantHasConfluence,
				crossJoinStatus,
				originProduct,
				requestedProduct,
				isLivePage,
				isSiteAdmin: tenantContext?.isSiteAdmin,
				linkObjectType,
				confluenceContentId,
				contentType,
			};
			fireEmbeddedConfluenceAnalytics({
				analyticsEvent,
				attributes,
				eventType,
				eventName: `${actionSubject ?? eventName} ${action}`,
			});
		},
		[source, tenantContext, createAnalyticsEvent],
	);

	return trackEmbeddedConfluence;
};
